module.exports = "/_next/static/images/hand-duotone-d7c3e65cba9dda8c0b3b54b9595bbcb0.svg";